import React from 'react';

const DocumentationViewer = ({ src, title }) => {
    return (
        <div
            style={{
                width: '100%',
                height: 'calc(100vh - 120px)',
                border: '1px solid #e2dfda',
                borderRadius: 8,
                overflow: 'hidden',
                background: '#fff',
            }}
        >
            <iframe
                src={src}
                title={title}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default DocumentationViewer;
